import { useTranslation } from 'react-i18next';
import { CopyButton } from '@ui/copy-button.tsx';
import { ConfigurationPageLayout } from '@admin/components/workspace-configuration/configuration-page-layout.tsx';
import {
  useWorkspaceConfiguration,
  useWorkspaceConfigurationQuery
} from '@admin/components/workspace-configuration/use-workspace-configuration.ts';

export const EmailConfiguration = () => {
  const { t } = useTranslation();
  const { workspaceId } = useWorkspaceConfiguration();
  const configurationQuery = useWorkspaceConfigurationQuery();
  const emailConfiguration = configurationQuery.data?.emailConfiguration;

  const senderEmail = emailConfiguration?.senderEmail;

  return (
    <ConfigurationPageLayout
      scope="email"
      title={t('workspace.configuration.email.title')}
      description={t('workspace.configuration.email.description')}
      workspaceId={workspaceId}
      subject={
        senderEmail ? (
          <span className="flex items-center gap-2">
            {senderEmail}
            <CopyButton value={senderEmail} />
          </span>
        ) : (
          emailConfiguration && (
            <span className="font-normal text-muted-foreground">
              {t('workspace.configuration.email.sender.missing')}
            </span>
          )
        )
      }
      isValid={emailConfiguration?.isValid}
      records={emailConfiguration?.records}
      isLoading={configurationQuery.isLoading}
      isError={configurationQuery.isError}
    />
  );
};
